<template>
  <div class="default-bg start">
    <Loading></Loading>
    <Header :bg_image="`topbanner_${color_idx}.png`" :color_idx="'' + color_idx"></Header>

    <div class="content">
      <h1 :class="`color${color_idx}`">命定色心理測驗</h1>
      <p>你夠了解自己嗎？</p>
      <p>透過簡單的心理測驗，找出專屬於你的命定色</p>
      <p>用顏色快速了解你的潛在風格！</p>
      <router-link :to="{ name: 'quiz', params: { id: '1' } }">找出你的專屬命定色</router-link>
    </div>

    <Footer :bg_image="`botbanner_${color_idx}.png`"></Footer>
  </div>
</template>

<script>
import Loading from '@/components/Loading.vue'
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import { setTimeout } from 'timers';
export default {
  name: "start",
  components: {
    Loading,
    Header,
    Footer
  },
  data() {
    return {
      color_idx: 1
    }
  },
  mounted() {
    document.onreadystatechange = () => { 
      if (document.readyState == "complete") { 
        // run code here
        console.log('loaded')
        this.$store.commit('setLoaded')
      } 
    }
  },
  created() {
    let vm = this;
    setInterval(() => {
      vm.color_idx = vm.color_idx % 7 + 1
    }, 2000);

    setTimeout(() => {
      vm.$store.commit('setLoaded')
    }, 5000);
  }
}
</script>

<style lang="scss">
  @keyframes fadeInButton {
    from { opacity: 0; }
    to { opacity: 1; }
  }
  .start {
    animation: fadeInContent 3s;
    .content {
      h1 {
        font-size: 3rem;
        margin-top: 70px;
        margin-bottom: 40px;
        transition: .4s ease-in-out;
      }
      p {
        margin-bottom: 6px;
      }
      a {
        font-size: 1.2rem;
        width: 300px;
        margin: 0 auto;
        margin-top: 34px;
        padding: 7px 0;
        color: $text-gray;
        background-color: rgba(216,216,216,.6);
        border: #979797 0.1px solid;
        box-shadow: 2px 2px 6px #999999;
        animation: fadeInContent 3s;
      }
    }
  }
  @media screen and (max-width: 768px) {
    .start {
      .content { 
        h1 {
          font-size: 2.5rem;
          margin-top: 50px;
        }
      }
    }
  }
  @media screen and (max-width: 330px) {
    .start {
      .content { 
        h1 {
          font-size: 2.3rem;
          margin-top: 50px;
        }
        p {
          font-size: .9rem;
        }
      }
    }
  }
</style>